app.service('regon', function () {

	function init(name) {
        window.regon(name);
	}

	return { init };
});
